import React from 'react'
import { UploadDashboard } from '../uppy/upload-dashboard'

const GB = 1024 * 1024 * 1024

export const TransferFileUploadAssetVersion = ({ asset, onComplete }) => {
  if (!asset?.id) return null
  return (
    <UploadDashboard
      base={process.env.REACT_APP_API_STORAGE}
      path="api/v1/file-content-multipart"
      initParams={{ assetID: asset.id }}
      endpointGroup="content"
      targetId={`content:${asset.id}`}
      maxFileSize={5 * GB}
      onComplete={onComplete}
    />
  )
}
